/**
 * Persistent User ID System
 *
 * Uses the user's email (base64 encoded) as a persistent identifier across apps.
 * Stored in localStorage to survive cookie expiration and browser restarts.
 */

const PERSISTENT_ID_KEY = 'stokastic_user_id';

/**
 * Encodes email to base64 for use as persistent ID
 */
export function encodeEmail(email: string): string {
  return btoa(email.toLowerCase().trim());
}

/**
 * Sets the persistent user ID from email on login
 */
export function setPersistentUserId(email: string): void {
  try {
    const encodedId = encodeEmail(email);
    localStorage.setItem(PERSISTENT_ID_KEY, encodedId);
  } catch (error) {
    console.warn('Failed to set persistent user ID:', error);
  }
}

/**
 * Gets the persistent user ID from localStorage
 */
export function getPersistentUserId(): string | null {
  try {
    return localStorage.getItem(PERSISTENT_ID_KEY);
  } catch (error) {
    console.warn('Failed to get persistent user ID:', error);
    return null;
  }
}

/**
 * Clears the persistent user ID (call on logout)
 */
export function clearLinkedUserId(): void {
  try {
    localStorage.removeItem(PERSISTENT_ID_KEY);
  } catch (error) {
    console.warn('Failed to clear persistent user ID:', error);
  }
}
